import type { FC } from 'react';

import { MyLocationIcon } from '@/assets';
import { ListItem } from '@/features/list/components/ListItem';
import { LocationGuard } from '@/shared/components/location/LocationGuard';

type CurrentLocationListItemProps = {
  onPress: () => void;
  title: string;
  description?: string;
  numberOfLinesDescription?: number;
};

export const CurrentLocationListItem: FC<CurrentLocationListItemProps> = ({
  onPress,
  title,
  description,
  numberOfLinesDescription
}) => (
  <LocationGuard>
    <ListItem
      onPress={onPress}
      title={title}
      description={description}
      numberOfLinesDescription={numberOfLinesDescription}
      textOrder={description ? 'column-reverse' : 'column'}
      hideRightArrow
      icon={MyLocationIcon}
      iconSize={24}
    />
  </LocationGuard>
);
